import React, { useEffect, useState } from "react";

export default function ErrorBoundary({ children }) {
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const errorHandler = (event) => {
      console.error("Error caught by window:", event.error);
      setError(event.error);
      setHasError(true);
    };

    window.addEventListener("error", errorHandler);
    return () => window.removeEventListener("error", errorHandler);
  }, []);

  if (hasError) {
    return (
      <div style={{ padding: "20px", color: "red" }}>
        <h2>Có lỗi xảy ra vui lòng tải lại trang...</h2>
        {error && <pre>{error.message}</pre>}
      </div>
    );
  }

  return children;
}
